module.exports = __webpack_public_path__ + "static/media/logo.c2afe62e.png";